export enum AspectCode {
  Accounting = "acc",
  AIBookkeeper = "aib",
  AdvancedLedger = "adv",
  AskDigits = "ask",
  Audit = "adt",
  AutomatedBankRecs = "abr",
  AutomatedReceiptHandling = "arh",
  BankRecChecklist = "brc",
  BanksAndCards = "bnc",
  CategoryManager = "cmg",
  ClosedPeriod = "clp",
  Connections = "cnx",
  CustomerDirectory = "cdr",
  DimensionManager = "dmg",
  Employments = "emp",
  Financials = "fin",
  FirmBranding = "fbg",
  FirmLevelPredictions = "flp",
  FutureDatedTransactions = "fdt",
  Collect = "gpd", // Formerly Get Paid
  Home = "hom",
  InvoiceCreditCards = "icc",
  InvoiceManualBankAccount = "imb",
  Invoicing = "inv",
  LedgerBills = "lgb",
  MultiCustomDashboards = "mcd",
  OrganizationClientManagement = "ocp",
  PayBills = "pbl",
  QuarterlyDashboard = "qtr",
  Reports = "rpt",
  RestrictLedgerEdits = "rle",
  Schedules = "sch",
  Sharing = "shr",
  SSOUserCreation = "sso",
  TransactionActionItems = "tai",
  Upsells = "ups",
  Vault = "vlt",
  VendorDirectory = "vdr",
}
